<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-lg-12 col-md-12 col-sm-12 traveller-heading accordion-toggle">
      <div class="row">
        <div>
          <button
            id = "non_nil_corr_in_cust_detail"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#polDetails"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Non Nil-Correction In Customer Detail</h3>
      </div>
    </div>
    <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="NonNilCorrCustomerDetail">
    <div class="risk row">
        <!-- Gender* starts-->
        <div class=" col-lg-3 col-md-3 col-sm-6 " v-if="nonNilCorrCustomerDetailData.gender.visibility && searchPartyData.partyType == 'I'">
          <div class="row form-group">
            <float-label
              label="Gender"
              :fixed="isFloat(nonNilCorrCustomerDetailData.gender.value)">
            <select
              class="form-control"
              placeholder="Gender"
              v-model="nonNilCorrCustomerDetailData.gender.value"
              v-evolvews="nonNilCorrCustomerDetailData.gender"
              :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.gender.errorText!=='' }"
              @change='genderChange()'
            >
            <option disabled :value='null' v-if='nonNilCorrCustomerDetailData.gender.value == null'>Gender</option>
            <option disabled value=''  v-if='nonNilCorrCustomerDetailData.gender.value == ""'>Gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
            </select>
            </float-label>
            <span
              class="error-text"
              v-if="nonNilCorrCustomerDetailData.gender.errorText !== ''"
            >{{ nonNilCorrCustomerDetailData.gender.errorText }}</span>
          </div>
        </div>
        <!-- Gender* ends-->
        <!--Title* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.title.visibility && searchPartyData.partyType == 'I'">
                <div class="row form-group">
                    <float-label label="Title*" :fixed="isFloat(nonNilCorrCustomerDetailData.title.value)"> 
                        <select
                          v-model="nonNilCorrCustomerDetailData.title.value"
                          v-evolvews="nonNilCorrCustomerDetailData.title"
                          :class="{'bgc-error-field':nonNilCorrCustomerDetailData.title.errorText !== ''}"
                          class="form-control"
                          :disabled="nonNilCorrCustomerDetailData.title.disabled"
                        >
                          <option disabled value='' v-if="nonNilCorrCustomerDetailData.title.value==''">Title*</option>
                          <option disabled :value='null' v-if="nonNilCorrCustomerDetailData.title.value==null">Title*</option>
                          <option v-for="title in searchPartyData.titleArray" :key="title.code" :value="title.code">{{title.name}}</option>
                        </select>
                    </float-label>
                    <span class="error-text" v-if="nonNilCorrCustomerDetailData.title.errorText !== ''">
                        {{nonNilCorrCustomerDetailData.title.errorText}}</span>
                </div>
            </div>
        <!--Title ends-->
        <!--DOB* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.dob.visibility && searchPartyData.partyType == 'I'">
            <div class="row form-group">
              <float-label label="DOB" :fixed="isFloat(nonNilCorrCustomerDetailData.dob.value)">
                <datepicker
                  v-model="nonNilCorrCustomerDetailData.dob.value"
                  v-evolvews="nonNilCorrCustomerDetailData.dob"
                  :typeable="true"
                  format="dd/MM/yyyy"
                  :disabledDates="disableDOB"
                  placeholder="DOB"
                  :input-class="isInputError(nonNilCorrCustomerDetailData.dob.errorText)"
                  @selected="checkError(nonNilCorrCustomerDetailData.dob,false)"
                  @input="checkError(nonNilCorrCustomerDetailData.dob,false)"
                ></datepicker>
              </float-label>
              <span
                class="error-text"
                v-if="nonNilCorrCustomerDetailData.dob.errorText !== ''"
              >{{nonNilCorrCustomerDetailData.dob.errorText}}</span>
            </div>
        </div>
        <!--DOB ends-->
        <!--Mailing Pincode* starts-->
        <div class="col-lg-3 col-md-3 col-sm-6"
          v-if="nonNilCorrCustomerDetailData.mailingPincode.visibility">
          <div class="row form-group">
            <float-label label="Mailing Pincode*" :fixed="isFloat(nonNilCorrCustomerDetailData.mailingPincode.value)"> 
              <input
                v-model="nonNilCorrCustomerDetailData.mailingPincode.value"
                v-evolvews="nonNilCorrCustomerDetailData.mailingPincode"
                :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.mailingPincode.errorText!=='' }"
                type="text"
                @input='onlyNumberMotor($event,nonNilCorrCustomerDetailData.mailingPincode)'
                maxlength="6"
                class="form-control"
                @blur="callGetAreaByPinCode()"
                placeholder="Mailing Pincode*"
              />
            </float-label>
            <span
              class="error-text"
              v-if="nonNilCorrCustomerDetailData.mailingPincode.errorText !== ''"
            >{{ nonNilCorrCustomerDetailData.mailingPincode.errorText }}</span>
          </div>
        </div>
        <!--Mailing Pincode* ends-->

    </div>
    <div class='risk row'>
      <!-- City starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.city.visibility">
            <div class="row form-group">
            <float-label label="City*" :fixed="isFloat(nonNilCorrCustomerDetailData.city.value)">
              <input
                disabled
                type="text"
                class="form-control"
                placeholder="City*"
                v-on:keydown="onlyChar"
                v-model="nonNilCorrCustomerDetailData.city.value"
                :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.city.errorText!=='' }"
                v-evolvews="nonNilCorrCustomerDetailData.city"
              />
            </float-label>
            <span
              class="error-text"
              v-if=" nonNilCorrCustomerDetailData.city.errorText!==''"
            >{{ nonNilCorrCustomerDetailData.city.errorText}}</span>
            </div>
          </div>
          <!-- City end-->
          <!-- State starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.state.visibility">
            <div class="row form-group">
            <float-label label="State*" :fixed="isFloat(nonNilCorrCustomerDetailData.state.value)">
              <input
                disabled
                type="text"
                class="form-control"
                placeholder="State*"
                v-on:keydown="onlyChar"
                v-model="nonNilCorrCustomerDetailData.state.value"
                :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.state.errorText!=='' }"
                v-evolvews="nonNilCorrCustomerDetailData.state"
              />
            </float-label>
            <span
              class="error-text"
              v-if=" nonNilCorrCustomerDetailData.state.errorText!==''"
            >{{ nonNilCorrCustomerDetailData.state.errorText}}</span>
            </div>
          </div>
          <!-- State end-->
          <!-- Area starts-->
          <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.area.visibility">
            <div class="row form-group">
            <float-label
              label="Area*"
              :fixed="isFloat(nonNilCorrCustomerDetailData.area.value)"
            >
              <select
                class="form-control"
                placeholder="Area*"
                :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.area.errorText!=='' }"
                v-evolvews="nonNilCorrCustomerDetailData.area"
                v-model="nonNilCorrCustomerDetailData.area.value"
              >
                <option disabled value='' v-if="nonNilCorrCustomerDetailData.area.value==''">Area*</option>
                <option disabled :value='null' v-if="nonNilCorrCustomerDetailData.area.value==null">Area*</option>
                <option
                  v-for="area in areas"
                  :key="area.areaCode"
                  :value="area.areaCode"
                >{{area.areaName}}</option>
              </select>
            </float-label>
            <span
              class="error-text"
              v-if=" nonNilCorrCustomerDetailData.area.errorText!==''"
            >{{ nonNilCorrCustomerDetailData.area.errorText}}</span>
            </div>
          </div>
          <!-- Area end-->
    </div>
    <div class="risk row">
        <!-- Aadhaar No starts -->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.aadharCardNumber.visibility">
          <div class="row form-group">
          <float-label
            label="Aadhaar No"
            :fixed="isFloat(nonNilCorrCustomerDetailData.aadharCardNumber.value)"
          >
            <input
              type="text"
              placeholder="Aadhaar No"
              class="form-control"
              v-on:keydown="onlyNumber"
              maxLength='12'
              v-evolvews="nonNilCorrCustomerDetailData.aadharCardNumber"
              v-model="nonNilCorrCustomerDetailData.aadharCardNumber.value"
            />
          </float-label>
          <span
            class="error-text" v-if="nonNilCorrCustomerDetailData.aadharCardNumber.errorText !== ''" >
            {{nonNilCorrCustomerDetailData.aadharCardNumber.errorText}}</span>
          </div>
        </div>
        <!-- Aadhaar No ends -->
        <!-- GST NO update starts -->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.gstNumber.visibility">
          <div class="row form-group">
          <float-label
            label="GST NO update"
            :fixed="isFloat(nonNilCorrCustomerDetailData.gstNumber.value)"
          >
            <input
              type="text"
              placeholder="GST NO update"
              maxlength="15"
              class="form-control capital-input"
              @blur="validateGstUsingPAN()"
              :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.gstNumber.errorText!=='' }"
              v-on:keyup="alphaNumeric"
              v-evolvews="nonNilCorrCustomerDetailData.gstNumber"
              v-model="nonNilCorrCustomerDetailData.gstNumber.value"
            />
          </float-label>
          <span class="pan-validated success-gst"
            v-show="!nonNilCorrCustomerDetailData.gstNumber.errorText && gstNameStatus">{{gstNameStatus.split(':')[0]}} : <span class="font-weight-bold">{{gstNameStatus.split(':')[1]}}</span></span>
          <span
            class="error-text" v-if="nonNilCorrCustomerDetailData.gstNumber.errorText !== ''" >
            {{nonNilCorrCustomerDetailData.gstNumber.errorText}}</span>
          <span v-if="validateGstLoader" class="search-loader-gst small inline"><img src="@/assets/images/loader.gif" alt="Pan Loader"
            class="search-loader-breakdown"/></span>
          </div>
        </div>
        <!-- GST NO update ends -->
        <!-- Insured’s PAN starts -->
        <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.panNumber.visibility">
          <div class="row form-group">
          <float-label
            label="Insured’s PAN"
            :fixed="isFloat(nonNilCorrCustomerDetailData.panNumber.value)"
          >
            <input
              type="text"
              placeholder="Insured’s PAN"
              maxlength="10"
              v-on:keyup="alphaNumeric"
              @change="resetPanText()"
              class="form-control capital-input"
              v-evolvews="nonNilCorrCustomerDetailData.panNumber"
              v-model="nonNilCorrCustomerDetailData.panNumber.value"
              :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.panNumber.errorText!=='' }"
            />
          </float-label>
          <span class="pan-validated" :class="{'success-pan':(panValidate!=='Unsuccessful' && panValidate!=='Please enter a PAN before proceeding')}" 
            v-show="!nonNilCorrCustomerDetailData.panNumber.errorText && panValidate">{{panValidate}}<span class="font-weight-bold">{{panNameStatus}}</span></span>
          <span
            class="error-text" v-if="nonNilCorrCustomerDetailData.panNumber.errorText !== ''" >
            {{nonNilCorrCustomerDetailData.panNumber.errorText}}</span>
          <span v-if="validatePanLoader" class="search-loader small inline"><img src="@/assets/images/loader.gif" alt="Pan Loader"
            class="search-loader-breakdown"/></span>
          </div>
        </div>
        <!-- Insured’s PAN ends -->
        <div class="col-lg-3 col-md-3 col-sm-6 pr-0" v-if="nonNilCorrCustomerDetailData.panNumber.visibility">
          <div class="row form-group adv-search-div ml-0">
            <a
              href="#"
              class="add-wrapper bgc-links adv-search "
              data-toggle="collapse"
              data-target="#validatePan"
              @click="validatePan()"
            >Validate PAN Number</a>
          </div>
        </div>
    </div>
    <!-- <div class="risk row"> -->
        <!-- Party type* starts-->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
          <float-label
            label="Party type*"
            :fixed="isFloat(nonNilCorrCustomerDetailData.partyType.value)">
            <select
              class="form-control"
              placeholder="Party type*"
              v-model="nonNilCorrCustomerDetailData.partyType.value"
              v-evolvews="nonNilCorrCustomerDetailData.partyType"
              @change="setCpaApplicability()"
              :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.partyType.errorText!=='' }"
            >
            <option disabled selected value>Party type*</option>
            <option value="I">Individual</option>
            <option value="O">Organization</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="nonNilCorrCustomerDetailData.partyType.errorText !== ''"
          >{{ nonNilCorrCustomerDetailData.partyType.errorText }}</span>
          </div>
        </div> -->
        <!-- Party type* ends-->
        <!-- Compulsory PA Applicability (15 Lakh)* starts-->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6">
          <div class="row form-group">
            <float-label
            label="Compulsory PA Applicability (15 Lakh)*"
            :fixed="isFloat(nonNilCorrCustomerDetailData.cpaApplicability.value)">
            <select
              class="form-control"
              placeholder="Compulsory PA Applicability (15 Lakh)*"
              v-model="nonNilCorrCustomerDetailData.cpaApplicability.value"
              v-evolvews="nonNilCorrCustomerDetailData.cpaApplicability"
              :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.cpaApplicability.errorText!=='' }"
              :disabled="nonNilCorrCustomerDetailData.partyType.value == 'O'"
              @change='setExemptionReasons()'
            >
            <option disabled selected value>Compulsory PA Applicability (15 Lakh)*</option>
            <option disabled value='' v-if='nonNilCorrCustomerDetailData.cpaApplicability.value == ""'>Compulsory PA Applicability (15 Lakh)*</option>
            <option disabled :value='null' v-if='nonNilCorrCustomerDetailData.cpaApplicability.value == null'>Compulsory PA Applicability (15 Lakh)*</option>
            <option v-for="option in domainValues.cpaApplicabilityResponse.cpaApplicabilityList" :key="option.code" :value="option.code">{{option.name}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="nonNilCorrCustomerDetailData.cpaApplicability.errorText !== ''"
            >{{ nonNilCorrCustomerDetailData.cpaApplicability.errorText }}</span>
          </div>
        </div> -->
        <!-- Compulsory PA Applicability (15 Lakh)* ends-->
        <!--CPA Period* starts-->
            <!-- <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.cpaApplicability.value == 'C'">
              <div class="row form-group">
                <float-label label="CPA Period" :fixed="isFloat(nonNilCorrCustomerDetailData.cpaDuration.value)">
                  <select
                    class="form-control"
                    placeholder="CPA Period"
                    v-model="nonNilCorrCustomerDetailData.cpaDuration.value"
                    v-evolvews="nonNilCorrCustomerDetailData.cpaDuration"
                    :class="{'bgc-error-field':nonNilCorrCustomerDetailData.cpaDuration.errorText !== ''}"
                    >
                    <option disabled selected value>CPA Period</option>
                    <option disabled :value='null' v-if='nonNilCorrCustomerDetailData.cpaDuration.value == null'>CPA Period</option>
                    <option disabled value=''  v-if='nonNilCorrCustomerDetailData.cpaDuration.value == ""'>CPA Period</option>
                    <option v-for="cpaDuration in cpaDurationList" :key="cpaDuration" :value="cpaDuration">{{cpaDuration}}</option>
                  </select>
                </float-label>
                <span class="error-text" v-if="nonNilCorrCustomerDetailData.cpaDuration.errorText !== ''">
                  {{nonNilCorrCustomerDetailData.cpaDuration.errorText}}</span>
              </div>
            </div> -->
            <!--CPA Period* ends-->
        <!-- Exemption Reason* starts-->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.cpaApplicability.value == 'E'">
          <div class="row form-group">
            <float-label
            label="Exemption Reason*"
            :fixed="isFloat(nonNilCorrCustomerDetailData.exemptionReason.value)">
            <select
              class="form-control"
              placeholder="Exemption Reason*"
              :disabled="nonNilCorrCustomerDetailData.partyType.value == 'O' && nonNilCorrCustomerDetailData.cpaApplicability.value == 'E'"
              v-model="nonNilCorrCustomerDetailData.exemptionReason.value"
              v-evolvews="nonNilCorrCustomerDetailData.exemptionReason"
              :class="{ 'bgc-error-field': nonNilCorrCustomerDetailData.exemptionReason.errorText!=='' }"
            >
            <option disabled selected value>Exemption Reason*</option>
            <option disabled :value='null' v-if='nonNilCorrCustomerDetailData.exemptionReason.value == null'>Exemption Reason*</option>
            <option disabled value=''  v-if='nonNilCorrCustomerDetailData.exemptionReason.value == ""'>Exemption Reason*</option>
            <option v-for="exemptionReason in state.exemptionReasonsList" :key="exemptionReason.code" :value="exemptionReason.code">{{exemptionReason.name}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="nonNilCorrCustomerDetailData.exemptionReason.errorText !== ''"
            >{{ nonNilCorrCustomerDetailData.exemptionReason.errorText }}</span>
          </div>
        </div> -->
        <!-- Exemption Reason* ends-->
    <!-- </div> -->
    <!-- <div class="risk row"> -->
        <!-- Policy Number* starts -->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6 " v-if="nonNilCorrCustomerDetailData.cpaApplicability.value == 'E' && nonNilCorrCustomerDetailData.exemptionReason.value == 'AHPACO15L'">
          <div class="row form-group">
          <float-label
            label="Policy Number"
            :fixed="isFloat(nonNilCorrCustomerDetailData.paPolicyNumber.value)">
            <input
              type="text"
              v-on:keydown="onlyNumber"
              maxlength="30"
              placeholder="Policy Number"
              class="form-control"
              :class="{
                'bgc-error-field':nonNilCorrCustomerDetailData.paPolicyNumber.errorText !=='',
              }"
              v-evolvews="nonNilCorrCustomerDetailData.paPolicyNumber"
              v-model="nonNilCorrCustomerDetailData.paPolicyNumber.value"
            />
          </float-label>
          <span
            class="error-text" v-if="nonNilCorrCustomerDetailData.paPolicyNumber.errorText !== ''" >
            {{nonNilCorrCustomerDetailData.paPolicyNumber.errorText}}</span>
          </div>
        </div> -->
        <!-- Policy Number* ends -->
        <!-- Insurer Name starts -->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6 " v-if="nonNilCorrCustomerDetailData.cpaApplicability.value == 'E' && nonNilCorrCustomerDetailData.exemptionReason.value == 'AHPACO15L'">
          <div class="row form-group">
          <float-label
            label="Insurer Name"
            :fixed="isFloat(nonNilCorrCustomerDetailData.paInsurerName.value)">
            <input
              type="text"
              v-on:keydown="onlyCharSpace"
              placeholder="Insurer Name"
              maxlength="50"
              class="form-control"
              v-evolvews="nonNilCorrCustomerDetailData.paInsurerName"
              v-model="nonNilCorrCustomerDetailData.paInsurerName.value"
            />
          </float-label>
          <span
            class="error-text" v-if="nonNilCorrCustomerDetailData.paInsurerName.errorText !== ''" >
            {{nonNilCorrCustomerDetailData.paInsurerName.errorText}}</span>
          </div>
        </div> -->
        <!-- Insurer Name ends -->
        <!-- Policy Inception Date* starts-->
          <!-- <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.cpaApplicability.value == 'E' && nonNilCorrCustomerDetailData.exemptionReason.value == 'AHPACO15L'">
            <div class="row form-group">
              <float-label label="Policy Inception Date" :fixed="isFloat(nonNilCorrCustomerDetailData.paPolicyInceptionDate.value)">
                <datepicker
                  v-model="nonNilCorrCustomerDetailData.paPolicyInceptionDate.value"
                  v-evolvews="nonNilCorrCustomerDetailData.paPolicyInceptionDate"
                  :typeable="true"
                  format="dd/MM/yyyy"
                  :input-class="isInputError(nonNilCorrCustomerDetailData.paPolicyInceptionDate.errorText)"
                  @selected="checkError(nonNilCorrCustomerDetailData.paPolicyInceptionDate,false)"
                  @input="checkError(nonNilCorrCustomerDetailData.paPolicyInceptionDate,false)"
                  :disabledDates="disableInceptionDate" 
                  placeholder="Policy Inception Date"
                ></datepicker>
              </float-label>
              <span
                class="error-text"
                v-if="nonNilCorrCustomerDetailData.paPolicyInceptionDate.errorText !== ''"
              >{{nonNilCorrCustomerDetailData.paPolicyInceptionDate.errorText}}</span>
            </div>
          </div> -->
          <!--Policy Inception Date* ends-->
          <!--Policy Expiry Date* starts-->
          <!-- <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.cpaApplicability.value == 'E' && nonNilCorrCustomerDetailData.exemptionReason.value == 'AHPACO15L'">
            <div class="row form-group">
              <float-label label="Policy Expiry Date" :fixed="isFloat(nonNilCorrCustomerDetailData.paPolicyExpiryDate.value)">
                <datepicker
                  v-model="nonNilCorrCustomerDetailData.paPolicyExpiryDate.value"
                  v-evolvews="nonNilCorrCustomerDetailData.paPolicyExpiryDate"
                  :typeable="true"
                  format="dd/MM/yyyy"
                  :input-class="isInputError(nonNilCorrCustomerDetailData.paPolicyExpiryDate.errorText)"
                  @selected="checkError(nonNilCorrCustomerDetailData.paPolicyExpiryDate,false)"
                  @input="checkError(nonNilCorrCustomerDetailData.paPolicyExpiryDate,false)"
                  :disabledDates="disableExpiryDate" 
                  placeholder="Policy Expiry Date"
                ></datepicker>
              </float-label>
              <span
                class="error-text"
                v-if="nonNilCorrCustomerDetailData.paPolicyExpiryDate.errorText !== ''"
              >{{nonNilCorrCustomerDetailData.paPolicyExpiryDate.errorText}}</span>
            </div>
          </div> -->
          <!--Policy Expiry Date* ends-->
    <!-- </div> -->
    <!-- <div class="risk row"> -->
        <!-- PA Nominee Name starts -->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6 " v-if="nonNilCorrCustomerDetailData.cpaApplicability.value !== 'E'">
          <div class="row form-group">
          <float-label
            label="PA Nominee Name"
            :fixed="isFloat(nonNilCorrCustomerDetailData.paNomineeName.value)">
            <input
              type="text"
              v-on:keydown="onlyCharSpace"
              maxlength="30"
              placeholder="PA Nominee Name"
              class="form-control"
              v-evolvews="nonNilCorrCustomerDetailData.paNomineeName"
              v-model="nonNilCorrCustomerDetailData.paNomineeName.value"
            />
          </float-label>
          <span
            class="error-text" v-if="nonNilCorrCustomerDetailData.paNomineeName.errorText !== ''" >
            {{nonNilCorrCustomerDetailData.paNomineeName.errorText}}</span>
          </div>
        </div> -->
        <!-- PA Nominee Name ends -->
        <!-- PA Nominee Relation starts-->
        <!-- <div class=" col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.cpaApplicability.value !== 'E'">
          <div class="row form-group">
            <float-label
            label="PA Nominee Relation"
            :fixed="isFloat(nonNilCorrCustomerDetailData.paNomineeRelation.value)">
            <select
              class="form-control"
              placeholder="PA Nominee Relation"
              v-model="nonNilCorrCustomerDetailData.paNomineeRelation.value"
              v-evolvews="nonNilCorrCustomerDetailData.paNomineeRelation">
            <option disabled selected value>PA Nominee Relation</option>
            <option v-for="relation in domainValues.initMotorDomainLists.nomineeRelations" :key="relation.code" :value="relation.code">{{relation.name}}</option>
            </select>
          </float-label>
          <span
            class="error-text"
            v-if="nonNilCorrCustomerDetailData.paNomineeRelation.errorText !== ''"
            >{{ nonNilCorrCustomerDetailData.paNomineeRelation.errorText }}</span>
          </div>
        </div> -->
        <!-- PA Nominee Relation ends-->
        <!-- Nominee DOB starts-->
          <!-- <div class="col-lg-3 col-md-3 col-sm-6" v-if="nonNilCorrCustomerDetailData.cpaApplicability.value !== 'E'">
            <div class="row form-group">
              <float-label label="Nominee DOB">
                <datepicker
                  v-model="nonNilCorrCustomerDetailData.nomineeDob.value"
                  v-evolvews="nonNilCorrCustomerDetailData.nomineeDob"
                  :typeable="true"
                  format="dd/MM/yyyy"
                  :input-class="isInputError(nonNilCorrCustomerDetailData.nomineeDob.errorText)"
                  @datePickerBlurred="checkError(nonNilCorrCustomerDetailData.nomineeDob,false)"
                  placeholder="Nominee DOB"
                ></datepicker>
              </float-label>
              <span
                class="error-text" v-if="nonNilCorrCustomerDetailData.nomineeDob.errorText !== ''" >
                {{nonNilCorrCustomerDetailData.nomineeDob.errorText}}</span>
            </div>
          </div> -->
          <!--Nominee DOB ends-->
          <!-- PA Nominee Allocation (%) starts -->
        <!-- <div class="col-lg-3 col-md-3 col-sm-6 " v-if="nonNilCorrCustomerDetailData.cpaApplicability.value !== 'E'">
          <div class="row form-group">
          <float-label
            label="PA Nominee Allocation (%)"
            :fixed="isFloat(nonNilCorrCustomerDetailData.paNomineeAllocationPercentage.value)">
            <input
              type="text"
              v-on:keydown="onlyNumber"
              maxlength="3"              
              placeholder="PA Nominee Allocation (%)"
              @blur="checkError(nonNilCorrCustomerDetailData.paNomineeAllocationPercentage)"
              class="form-control"
              :class="{
                'bgc-error-field':nonNilCorrCustomerDetailData.paNomineeAllocationPercentage.errorText !=='',
              }"
              v-evolvews="nonNilCorrCustomerDetailData.paNomineeAllocationPercentage"
              v-model="nonNilCorrCustomerDetailData.paNomineeAllocationPercentage.value"
            />
          </float-label>
          <span
            class="error-text" v-if="nonNilCorrCustomerDetailData.paNomineeAllocationPercentage.errorText !== ''" >
            {{nonNilCorrCustomerDetailData.paNomineeAllocationPercentage.errorText}}</span>
          </div>
        </div> -->
        <!-- PA Nominee Allocation (%) ends -->
    <!-- </div> -->
    </div>   
  </div>
</template>
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import moment from "moment";
// import Breadcrumb from "@/../../shared_component/Breadcrumb.vue";
// import vSelect from "vue-select";
import { reactive, onUpdated, onMounted, computed } from "@vue/composition-api";

export default {
  name: "NonNilCorrCustomerDetail",
  props: ["nonNilCorrCustomerDetailData",'panNameStatus','validateGstLoader','gstNameStatus',"domainValues",'searchPartyData','panValidate','validatePanLoader','areas','isCpaMandatory','getSavedQuoteData','cpaDurationList'],
  components: {
    FloatLabel,
    Datepicker
  },
    setup(props, context) {
    let state = reactive({
      exemptionReasonsList : []
    });
    //onMounted
    onMounted(()=>{
      // setExemptionReasons();
      // setCpaApplicability('onMounted');
      genderChange('onMounted');
      if(props.searchPartyData.partyType == 'I'){
        delete props.nonNilCorrCustomerDetailData.title.skip;
        context.root.$set(props.nonNilCorrCustomerDetailData.title,'stepsMandatory',true);
      }
      else{
        context.root.$set(props.nonNilCorrCustomerDetailData.title,'stepsMandatory',false);
        context.root.$set(props.nonNilCorrCustomerDetailData.title,'skip',false);
      }
      context.parent.calculateSteps();
    });
    
    const isFloat=functions.isFloat
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const onlyNumber =  functions.onlyNumber;
    const alphaNumeric =  functions.alphaNumeric;
    const onlyCharSpace =  functions.onlyCharSpace;
    const onlyChar =  functions.onlyChar;
    function genderChange(calledFrom){
      props.searchPartyData.titleArray = [];
      props.nonNilCorrCustomerDetailData.title.value = '';
      props.nonNilCorrCustomerDetailData.title.errorText = '';
      if(props.nonNilCorrCustomerDetailData.gender.value == 'M'){
        props.searchPartyData.titleArray.push(
          {
            name: "Mr.",
            code: "MR"
          }
        );
        props.nonNilCorrCustomerDetailData.title.value = 'MR'
      } 
      else if (props.nonNilCorrCustomerDetailData.gender.value == 'F'){
        props.searchPartyData.titleArray.push(
          {
            name: "Mrs.",
            code: "MRS"
          },
          {
            name: "Ms.",
            code: "MS"
          }
        );
      }
      if(calledFrom == 'onMounted' && props.searchPartyData.title && ['MR','MRS','MS'].includes(props.searchPartyData.title)){
        props.searchPartyData.titleArray = [];
        if(props.searchPartyData.title == 'MR'){
          props.searchPartyData.titleArray.push(
            {
              name: "Mr.",
              code: "MR"
            }
          );
        }else if(props.searchPartyData.title == 'MS' || props.searchPartyData.title == 'MRS'){
          props.searchPartyData.titleArray.push(
            {
              name: "Mrs.",
              code: "MRS"
            },
            {
              name: "Ms.",
              code: "MS"
            }
          );
        }
        props.nonNilCorrCustomerDetailData.title.value = props.searchPartyData.title;
        // if(props.nonNilCorrCustomerDetailData.title.value == 'MR'){
        //   props.nonNilCorrCustomerDetailData.gender.value = 'M';
        // }else{
        //   props.nonNilCorrCustomerDetailData.gender.value = 'F';
        // }
      }
    }
    function callGetAreaByPinCode(){
      if(props.nonNilCorrCustomerDetailData.mailingPincode.errorText == ''){
        props.nonNilCorrCustomerDetailData.area.value = '';
        context.parent.getAreaDetailsByPinCode();
      }
    }
    function validatePan(){
      if(props.nonNilCorrCustomerDetailData.panNumber.value && props.nonNilCorrCustomerDetailData.panNumber.errorText =='')
        context.parent.validatePan();
      else{
        let value = props.nonNilCorrCustomerDetailData.panNumber.value;
        context.parent.checkPan(value);
      }
    }
    function resetPanText(){
        context.parent.resetPanText();
    }
    function validateGstUsingPAN(){
      if(props.nonNilCorrCustomerDetailData.gstNumber.value && !props.nonNilCorrCustomerDetailData.gstNumber.errorText){
        let extractedPan = props.nonNilCorrCustomerDetailData.gstNumber.value.substring(2,12);
        context.parent.validatePan('nonNil',extractedPan, true);
      }
    }
    function onlyNumberMotor(e,targetObj){
      context.parent.onlyNumberMotor(e,targetObj);
    }
    onUpdated(()=>{
      let progressStep = 0;
      Object.values(props.nonNilCorrCustomerDetailData).forEach(obj => {
        if(obj.stepsMandatory){
          if(obj.value && !obj.errorText){
            progressStep++;
          }
        }
      })
      context.parent.updateSteps(progressStep);
      context.parent.enableCalculatePremiumBtn('nonNilCorrCustomerDetail');
    })
    const disableInceptionDate= computed(()=>{
      return {
        from: moment(new Date()).add(1,'d').startOf('day').toDate()
      }
    })
    const disableExpiryDate= computed(()=>{
      return {
        to: moment(new Date()).subtract(1,'d').toDate()
      }
    })
    const disableDOB= computed(()=>{
      return {
        from: moment(new Date()).subtract(18,'y').startOf('day').toDate()
      }
    })
    return {
      state,
      isFloat,
      onlyNumberMotor,
      checkError,
      isInputError,
      onlyNumber,
      onlyChar,
      alphaNumeric,
      onlyCharSpace,
      resetPanText,
      validatePan,
      validateGstUsingPAN,
      callGetAreaByPinCode,
      disableInceptionDate,
      disableExpiryDate,
      // setExemptionReasons,
      // setCpaApplicability,
      genderChange,
      disableDOB
    };
  },
  directives: {
    evolvews: functions.evolvews,
  },
};
</script>
<style scoped>
a.bgc-links.adv-search {
  text-decoration: underline;
  font-size: 14px;
  color: #0872b9;
  font-weight: 400;
}
.pan-validated.success-pan{
  color: green;
  font-size: 14px;
}
.pan-validated{
  color: #f77a7a;
  font-size: 13px;
  margin-top: 7px;
}
.search-loader-gst img{
  width: 25px;
  height: 25px;
  left: 83%;
  top: 45%;
  position: absolute;
}
.capital-input{
  text-transform:uppercase;
}
::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: none;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: none;
}
::placeholder { /* Recent browsers */
  text-transform: none;
}
.success-gst{
  color: #0070be;
  font-size: 14px
}
.search-loader img{
  width: 25px;
  height: 25px;
  left: 80%;
  top: 37%;
  position: absolute;
}
@media (max-width: 575px) {
  .search-number {
    margin-bottom: 0px;
  }
  .adv-search-div {
    margin-top: 0px;
  }
  .add-wrapper {
    line-height: 20px;
  }
}
</style>